import React, { useState } from 'react';
import { Copy, Check, Pencil, RefreshCw, RotateCcw } from 'lucide-react';
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const MessageActions = ({ text, onAction, onEdit, role }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const safeText = typeof text === 'string' ? text : '';
    const cleanText = safeText.replace(/<thought>[\s\S]*?<\/thought>/g, '').replace(/<commands>[\s\S]*?<\/commands>/g, '').trim();
    navigator.clipboard.writeText(cleanText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    toast.success("Copied to clipboard");
  };

  return (
    <div className="flex items-center gap-1 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
      <button onClick={handleCopy} className="p-1.5 rounded-lg hover:bg-white/5 text-sonas-dim hover:text-sonas-text transition-colors" title="Copy content">
        {copied ? <Check className="h-3.5 w-3.5 text-sonas-accent" /> : <Copy className="h-3.5 w-3.5" />}
      </button>
      {role === 'user' && (
        <button onClick={onEdit} className="p-1.5 rounded-lg hover:bg-white/5 text-sonas-dim hover:text-sonas-text transition-colors" title="Edit message">
          <Pencil className="h-3.5 w-3.5" />
        </button>
      )}
      <button onClick={onAction} className={cn("p-1.5 rounded-lg hover:bg-white/5 transition-colors", role === 'assistant' ? "text-sonas-dim hover:text-sonas-accent" : "text-sonas-dim hover:text-red-400")} title={role === 'assistant' ? "Regenerate response" : "Rollback to here"}>
        {role === 'assistant' ? <RefreshCw className="h-3.5 w-3.5" /> : <RotateCcw className="h-3.5 w-3.5" />}
      </button>
    </div>
  );
};

export default MessageActions;